import { useState } from "react";
import {
  CheckIcon,
  MapPinIcon,
  PauseIcon,
  PlayIcon,
} from "@phosphor-icons/react";

import api, { formatApiError } from "../../lib/api";
import { ErrorBanner } from "../crm/Form";

// Forward-only transitions for technicians.
const ALLOWED_TECH_NEXT = {
  assigned: [{ to: "en_route", label: "En Route", icon: PlayIcon }],
  en_route: [{ to: "on_site", label: "On Site", icon: MapPinIcon }],
  on_site: [
    { to: "paused", label: "Pause", icon: PauseIcon },
    { to: "completed", label: "Complete", icon: CheckIcon, primary: true },
  ],
  paused: [{ to: "on_site", label: "Resume", icon: PlayIcon }],
};

export default function StatusActionBar({
  wo,
  isAssigned,
  onChange,
  dataTestPrefix = "status-action",
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  if (!isAssigned) return null;
  const actions = ALLOWED_TECH_NEXT[wo.status] || [];
  if (actions.length === 0) return null;

  const apply = async (target) => {
    setErr("");
    setBusy(true);
    try {
      await api.post(`/work-orders/${wo.id}/status`, { status: target });
      onChange();
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="status-action-bar" className="space-y-2">
      <ErrorBanner message={err} />
      <div className="flex flex-wrap gap-2">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <button
              key={a.to}
              type="button"
              disabled={busy}
              data-testid={`${dataTestPrefix}-${a.to}`}
              onClick={() => apply(a.to)}
              className={`inline-flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
                a.primary
                  ? "bg-emerald-600 text-white hover:bg-emerald-700 focus-visible:ring-emerald-500"
                  : "bg-slate-900 text-white hover:bg-slate-800 focus-visible:ring-amber-500"
              }`}
            >
              <Icon size={14} weight="bold" />
              {a.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
